export const INITIAL_STATE = {
    weight: '',
    height: '',
    imc: '',
    bodySurface: '',
    heartRate: '',
    breathingFrequency: '',
    bloodPressureMM: '',
    bloodPressureHg: ''
}

export const vitalSignsReducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_INPUT":
            return {
                ...state,
                [action.payload.name]: action.payload.value
            }
        case "CALCULATE_IBM_MC":
            let weight = action.payload.name === 'weight' ? parseFloat(action.payload.value) : parseFloat(state.weight);
            let height = action.payload.name === 'height' ? parseFloat(action.payload.value) : parseFloat(state.height);
            let imc = 0.0;
            let bodySurface = 0.0;
            if (height !== '' && height !== '0') {
                let isDecimal = height % 1 !== 0;
                let heightForBMI = isDecimal ? height : height / 100;
                let heightForSC = isDecimal ? height * 100 : height;
                imc = (parseFloat(weight) / (Math.pow((heightForBMI), 2))).toFixed(2)
                bodySurface = (Math.sqrt(((parseFloat(weight)) * (heightForSC)) / 3600)).toFixed(2);
                console.log({ isDecimal, heightForBMI, heightForSC, imc, bodySurface, weight })
            }
            return {
                ...state,
                [action.payload.name]: action.payload.value,
                imc,
                bodySurface
            }
        case "CHARGE_FIELDS":
            return {
                ...state,
                weight: action.payload.peso,
                height: action.payload.talla,
                imc: action.payload.masa_corporal,
                bodySurface: action.payload.superficie_corporal,
                heartRate: action.payload.frecuencia_cardiaca,
                breathingFrequency: action.payload.frecuencia_respiratoria,
                bloodPressureMM: action.payload.presion_arterial,
                bloodPressureHg: action.payload.presion_arterial2
            }
        case "CLEAR_FORM":
            return INITIAL_STATE
        default:
            state;
    }
}